import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-[#0F2942] text-white py-12 px-6">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-start gap-8">
        <div className="space-y-4">
          <img src="/assets/logo.png" alt="Dr. Alvará" className="h-12 md:h-16 w-auto brightness-0 invert" />
          <p className="text-white/60 text-sm max-w-xs leading-relaxed">
            R. Luís Spiandorelli Neto, 30 - Jardim Paiquere, Valinhos - SP, 13271-570, Sala 206, Torre Paineiras
          </p>
        </div>
        
        <div className="flex gap-8 text-sm pt-4">
          <a href="#sobre" className="hover:text-brand-blue transition-colors">Sobre</a>
          <a href="#servicos" className="hover:text-brand-blue transition-colors">Serviços</a>
          <a href="#contato" className="hover:text-brand-blue transition-colors">Contato</a>
        </div>
      </div>
      <div className="max-w-6xl mx-auto mt-12 pt-8 border-t border-white/5 text-center text-xs text-white/40">
        © {new Date().getFullYear()} Dr. Alvará. Todos os direitos reservados.
      </div>
    </footer>
  );
};

export default Footer;
